<template>
  <span>
    <span @click="openModalAction" class="link">
      <img src="/images/icn_delete.svg">
      <span>キッズ削除</span>
    </span>
  </span>
</template>

<script>

export default {
  props: ['kidsId'],
  components: {},
  data () {
    return {};
  },
  watch: {
    callback: function () {
      this.dialogCallback();
    },
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    }
  },
  computed: {
    callback: function () {
      return this.$store.getters['message/callback'];
    }
  },
  methods: {
    openModalAction: function () {

      let option = {
        is2Button: true,
        buttonLabelL: '削除',
        buttonColorL: 'r',
        buttonLabelR: 'キャンセル',
        isButtonOnly: true,
        callbackL: 'unregister',
        callbackR: 'cancel',
        messages: ['キッズ登録を解除します', 'よろしいですか？']
      };

      this.$store.dispatch('message/open', option).then();

      scrollTo(0, 0);
    },
    dialogCallback: function () {
      console.log('callback', this.callback);

      if (this.callback === 'unregister') {

        // 登録解除
        this.unregister();

      } else if (this.callback === 'unregisterFinish') {

        // welcomeへ遷移
        this.$router.push({name: 'Welcome'});

      }

    },
    unregister: function () {
      console.log('unregisterAction');

      if (this.lock) {
        console.log('lock', this.lock);
        return;
      }

      this.lock = true;

      let param = {
        id: this.kidsId,
        s: this.$store.getters['auth/session']
      };

      this.$store.dispatch('kids/delete', param).then(() => {

        let status = this.$store.getters['kids/status'];

        if (status === 200) {

          let option = {
            is1Button: true,
            buttonLabel: '確認',
            isButtonOnly: false,
            callback: 'kidsUnregisterFinish',
            callbackO: 'kidsUnregisterFinish',
            messages: ['キッズを削除しました']
          };

          this.$store.dispatch('message/open', option).then();

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

        // ロック解除
        this.lock = false;

      }).catch((err) => {
        console.log(err);

        this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
        this.$router.push({name: 'UserSystemError'});

        // ロック解除
        this.lock = false;

      });
    }
  }
};

</script>

<style lang="scss" scoped>

  .link {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    color: #F55E5E;
    line-height: 20px;
  }

</style>
